import * as React from 'react';
import { SVGProps } from 'react';

const Individual = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M8.957 21V8.775c-1.383-.367-2.512-1.1-3.387-2.2a7.305 7.305 0 0 1-1.563-3.75c-.033-.233.05-.429.25-.587.2-.158.433-.237.7-.238.267 0 .5.07.7.213.2.143.317.338.35.587.183 1.2.7 2.2 1.55 3 .85.8 1.9 1.2 3.15 1.2h2.5c.5 0 .967.092 1.4.275.434.183.825.45 1.175.8l3.825 3.825a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.949.949 0 0 1-.7-.275l-3.25-3.25V21a.968.968 0 0 1-.288.713.964.964 0 0 1-.712.287.973.973 0 0 1-.712-.288.965.965 0 0 1-.288-.712v-5h-2v5a.968.968 0 0 1-.288.713.964.964 0 0 1-.712.287.973.973 0 0 1-.712-.288.965.965 0 0 1-.288-.712Zm3-15c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 0 1 9.957 4c0-.55.195-1.021.588-1.412.393-.39.864-.587 1.412-.588a1.92 1.92 0 0 1 1.413.588c.394.393.59.864.587 1.412a1.95 1.95 0 0 1-.587 1.413A1.9 1.9 0 0 1 11.957 6Z"
    />
  </svg>
);
export default Individual;
